// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"6431": "bdb4095c","6886": "1f9722a0","7219": "f505a585","7344": "7768a0d8","7567": "80895c90",}[chunkId] + ".css"
}